import { type SubsProduct } from '~/vendor/cx-web/domain-types';

/**
 * Gets the default product from a list of products based on the isDefaultWhenSingleOption flag
 * The flag is stored in the product's metadata from the repub config
 * Falls back to the first product if no default is explicitly marked
 * @param products - Array of subscription products
 * @returns The default product, first product as fallback, or undefined if array is empty
 */
export function getDefaultProduct(products: SubsProduct[]): SubsProduct | undefined {
  const defaultProduct = products.find(product => product.isDefaultWhenSingleOption === true);
  return defaultProduct || products[0];
}
